import React from 'react';
import { CrossIcon } from '@datacamp/waffles-icons';

import { clearFlash } from 'helpers/flash';

import { Close, Content, Flash, Wrapper } from 'components/FlashBannerStyles';

const FlashBanner = () => (
  <Wrapper className="dc-flash-wrapper">
    <Flash className="dc-flash">
      <Content className="dc-flash__content" />
      <Close className="dc-flash__close" onClick={clearFlash}>
        <CrossIcon color="#fff" size={12} />
      </Close>
    </Flash>
  </Wrapper>
);

export default FlashBanner;
